<template>
  <div>
    <ul class="add">
      <li>
        <h6 v-if="items && items.length">
          {{ "total_questions" | setText("всего вопросов") }}:
          {{ items.length }}
        </h6>
        <button @click="add" class="btn btn-sm btn-info">
          <span class="ti-plus"></span>
          {{ "add_question" | setText("Добавить вопрос") }}
        </button>
      </li>
    </ul>
    <div>
      <div>
        <ul class="question">
          <li v-for="(item, key) in items" :key="key">
            <div>
              <h3>ВОПРОС: {{ key + 1 }}</h3>
              <radio-list
                v-model="item.type"
                :items="types"
                :name="`name_${item.id}`"
              />
              <fg-input
                type="text"
                name="title"
                :label="`Заголовок`"
                v-model="item.title"
              ></fg-input>

              <audio-upload-base :name="`item_${item['id']}`" v-model="item.audio_document"/>

              <label for=""
                >{{
                  "description_question" | setText("Описание (вопрос)")
                }}Описание (вопрос)</label
              >
              <quill-editor
                v-model="item.description"
                :options="$store.state.editorOption"
              />
            </div>
            <div class="answers" v-if="item.type === 'test'">
              <h6>
                {{
                  "add_variant_question" | setText("Добавить вариант ответа")
                }}
              </h6>
              <div class="group">
                <fg-input v-model="newAnswer.title" type="text"></fg-input>
                <checkbox v-model="newAnswer.is_true" color="#ffc107">{{
                  "right" | setText("Правильный")
                }}</checkbox>
                <button
                  @click="addVariant(key)"
                  class="btn btn-sm btn-info mt-2"
                >
                  {{ "add_answer" | setText("Добавить ответ") }}
                </button>
              </div>
              <h6>{{ "question_variants" | setText("Варианты ответов") }}</h6>
              <draggable
                :tag="'ul'"
                v-model="item.answers"
                handle=".handle"
                class="row"
              >
                <li
                  v-for="answer in item.answers"
                  :key="answer.id"
                  class="handle col-12 col-md-6"
                >
                  <div class="group">
                    <fg-input type="text" v-model="answer.title"></fg-input>
                    <audio-upload-base  :name="`answer_${answer['id']}`" v-model="answer.audio_document"/>
                    <img-upload-base64
                      :name="answer['id']"
                      v-model="answer.img"
                    />
                    <checkbox v-model="answer.is_true" color="#ffc107"
                      >{{ "right" | setText("Правильный") }}
                    </checkbox>
                    <checkbox v-model="answer.is_delete" color="#ffc107"
                      >{{ "delete" | setText("Удалить") }}
                    </checkbox>
                  </div>
                </li>
              </draggable>
            </div>
            <div class="answers" v-if="item.type === 'order'">
              <h6>
                {{
                  "add_variant_question" | setText("Добавить вариант ответа")
                }}
              </h6>
              <div class="group">
                <button
                  @click="addVariant(key)"
                  class="btn btn-sm btn-info mt-2"
                >
                  {{ "add_answer" | setText("Добавить ответ") }}
                </button>
              </div>
              <h6>{{ "question_variants" | setText("Варианты ответов") }}</h6>
              <draggable
                :tag="'ul'"
                v-model="item.answers"
                handle=".handle"
                class="row"
              >
                <li
                  v-for="answer in item.answers"
                  :key="answer.id"
                  class="handle col-12 col-md-6"
                >
                  <div class="group">
                    <fg-input type="text" v-model="answer.title"></fg-input>
                    <audio-upload-base :name="`answer_${answer['id']}`" v-model="answer.audio_document"/>
                    <img-upload-base64
                      :name="answer['id']"
                      v-model="answer.img"
                    />
                    <checkbox v-model="answer.is_delete" color="#ffc107"
                      >{{ "delete" | setText("Удалить") }}
                    </checkbox>
                  </div>
                </li>
              </draggable>
            </div>
            <div class="answers" v-if="item.type === 'glue'">
              <h6>
                {{
                  "add_variant_question" | setText("Добавить вариант ответа")
                }}
              </h6>
              <div class="group">
                <!-- <fg-input v-model="newAnswer.title" type="text"></fg-input> -->
                <!-- <checkbox v-model="newAnswer.is_true" color="#ffc107">{{ 'right' | setText('Правильный') }}</checkbox> -->
                <button
                  @click="addVariant(key)"
                  class="btn btn-sm btn-info mt-2"
                >
                  {{ "add_answer" | setText("Добавить ответ") }}
                </button>
              </div>
              <h6>{{ "question_variants" | setText("Варианты ответов") }}</h6>
              <draggable
                :tag="'ul'"
                v-model="item.answers"
                handle=".handle"
                class="row"
              >
                <li
                  v-for="answer in item.answers"
                  :key="answer.id"
                  class="handle col-12 col-md-6"
                >
                  <div class="group">
                    <fg-input type="text" v-model="answer.title"></fg-input>
                    <audio-upload-base :name="`answer_${answer['id']}`" v-model="answer.audio_document"/>
                    <img-upload-base64
                      :name="answer['id']"
                      v-model="answer.img"
                      :title="`Первое фото`"
                    />
                    <label>Группировать:</label>
                    <group-symbol
                      :answer="answer"
                      v-model="answer['group_symbol']"
                    />
                    <!-- <img-upload-base64 v-model="answer.img_second" :title="`Второе фото`" /> -->
                    <checkbox v-model="answer.is_delete" color="#ffc107"
                      >{{ "delete" | setText("Удалить") }}
                    </checkbox>
                  </div>
                </li>
              </draggable>
            </div>

            <div class="control">
              <button
                @click="updateItem(item, key)"
                class="btn btn-sm btn-success mr-2"
              >
                <span class="ti-save"></span>
                {{ "save" | setText("Сохранить") }}
              </button>
              <button
                @click="deleteItem(item, key)"
                class="btn btn-sm btn-danger"
              >
                <span class="ti-trash"></span>
              </button>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <modal name="add">
      <div class="ord">
        <div>
          <radio-list
            v-model="newItem.type"
            :items="types"
            :name="`name_new`"
          />
          <fg-input
            type="text"
            :label="`Заголовок`"
            v-model="newItem.title"
          ></fg-input>

          <label for="">{{
            "description_question" | setText("Описание (вопрос)")
          }}</label>
          <quill-editor
            v-model="newItem.description"
            :options="$store.state.editorOption"
          />
        </div>

        <div class="answers" v-if="newItem.type === 'test'">
          <h6>
            {{ "add_answer_variant" | setText("Добавить вариант ответа") }}
          </h6>

          <div class="group">
            <fg-input v-model="newAnswer.title" type="text"></fg-input>
            <checkbox v-model="newAnswer.is_true" color="#ffc107">{{
              "right" | setText("Правильный")
            }}</checkbox>
            <button @click="addVariantNew" class="btn btn-sm btn-info mt-2">
              {{ "add_answer" | setText("Добавить ответ") }}
            </button>
          </div>

          <h6 v-if="newItem.answers.length">
            {{ "question_variants" | setText("Варианты ответов") }}
          </h6>
          <draggable
            :tag="'ul'"
            v-model="newItem.answers"
            handle=".handle-new"
            class="row"
          >
            <li
              v-for="answer in newItem.answers"
              :key="answer.id"
              class="col-12 col-md-6 handle-new"
            >
              <div class="group">
                <fg-input type="text" v-model="answer.title"></fg-input>

                <audio-upload-base :name="`answer_${answer['id']}`" v-model="answer.audio_document"/>

                <img-upload-base64
                  :name="answer['id']"
                  v-model="answer.img"
                  :title="`Первое фото`"
                />

        

                <checkbox v-model="answer.is_true" color="#ffc107">{{
                  "right" | setText("Правильный")
                }}</checkbox>
                <checkbox v-model="answer.is_delete" color="#ffc107">{{
                  "delete" | setText("Удалить")
                }}</checkbox>
              </div>
            </li>
          </draggable>
        </div>

        <div class="answers" v-else-if="newItem.type === 'glue'">
          <h6>
            {{ "add_answer_variant" | setText("Добавить вариант ответа") }}
          </h6>
          <div class="group">
            <button @click="addVariantNew" class="btn btn-sm btn-info mt-2">
              {{ "add_answer" | setText("Добавить ответ") }}
            </button>
          </div>

          <h6 v-if="newItem.answers.length">
            {{ "question_variants" | setText("Варианты ответов") }}
          </h6>

          <draggable
            :tag="'ul'"
            v-model="newItem.answers"
            handle=".handle-new"
            class="row"
          >
            <li
              v-for="answer in newItem.answers"
              :key="answer.id"
              class="col-12 col-md-6 handle-new"
            >
              <div class="group">
                <fg-input type="text" v-model="answer.title"></fg-input>


                <audio-upload-base :name="`answer_${answer['id']}`" v-model="answer.audio_document"/>

                <img-upload-base64
                  :name="answer['id']"
                  v-model="answer.img"
                  :title="`Первое фото`"
                />

              
                <label>Группировать:</label>

                <group-symbol
                  :answer="answer"
                  v-model="answer['group_symbol']"
                />
                <!-- <img-upload-base64 v-model="answer.img_second" :title="`Второе фото`" /> -->
                <checkbox v-model="answer.is_delete" color="#ffc107">{{
                  "delete" | setText("Удалить")
                }}</checkbox>
              </div>
            </li>
          </draggable>
        </div>

        <div class="answers" v-else-if="newItem.type === 'order'">
          <h6>
            {{ "add_answer_variant" | setText("Добавить вариант ответа") }}
          </h6>
          <div class="group">
            <button @click="addVariantNew" class="btn btn-sm btn-info mt-2">
              {{ "add_answer" | setText("Добавить ответ") }}
            </button>
          </div>
          <h6 v-if="newItem.answers.length">
            {{ "question_variants" | setText("Варианты ответов") }}
          </h6>
          <draggable
            :tag="'ul'"
            v-model="newItem.answers"
            handle=".handle-new"
            class="row"
          >
            <li
              v-for="answer in newItem.answers"
              :key="answer.id"
              class="col-12 col-md-6 handle-new"
            >
              <div class="group">
                <fg-input type="text" v-model="answer.title"></fg-input>

                <audio-upload-base :name="`answer_${answer['id']}`" v-model="answer.audio_document"/>
                <img-upload-base64
                  :name="answer['id']"
                  v-model="answer.img"
                  :title="`Первое фото`"
                />
                <checkbox v-model="answer.is_delete" color="#ffc107">{{
                  "delete" | setText("Удалить")
                }}</checkbox>
              </div>
            </li>
          </draggable>
        </div>

        <div class="control">
          <button @click="createItem" class="btn btn-sm btn-success mt-2 mr-2">
            <span class="ti-save"></span> {{ "save" | setText("Сохранить") }}
          </button>
          <button
            @click="$modal.hide('add')"
            class="btn btn-sm btn-warning mt-2"
          >
            Отмена
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { errorNotify } from "@/plugins/functions";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import draggable from "vuedraggable";
import GroupSymbol from "./GroupSymbol";
export default {
  components: {
    quillEditor,
    draggable,
    GroupSymbol,
  },
  data: () => ({
    newAnswer: {
      title: "",
      is_true: false,
      is_delete: false,
      group_symbol: null,
      id: new Date().getTime(),
    },
    newItem: {
      title: "",
      type: "test",
      answers: [],
      audio_document: null,
    },
    types: [
      { title: "Тест", id: "test" },
      { title: "Загрузка документа", id: "upload" },
      { title: "Текстовый ответ", id: "text" },
      { title: "Упорядоченность", id: "order" },
      { title: "Склеить", id: "glue" },
    ],
    addType: null,
    cardLink: "",
    items: [],
  }),
  props: ["id"],
  async created() {
    this.cardLink = `works/${this.id}/questions`;
    this.$loading(true);
    this.items = await this.$http
      .get(this.cardLink)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        errorNotify(error, this.$notify);
      })
      .finally(() => {
        this.$loading(false);
      });
  },
  methods: {
    addVariant(key) {
      this.items[key].answers.push({ ...this.newAnswer });
      this.newAnswer = {
        title: "",
        is_true: false,
        is_delete: false,
        group_symbol: null,
        id: new Date().getTime(),
      };
    },
    addVariantNew() {
      this.newItem.answers.push({ ...this.newAnswer });
      this.newAnswer = {
        id: new Date().getTime(),
        title: "",
        is_true: false,
        is_delete: false,
        group_symbol: null,
      };

      //console.log(this.newAnswer);
    },
    add(addType) {
      this.addType = addType;
      this.$modal.show("add");
    },
    async createItem() {
      this.$loading(true);

      let newItem = await this.$http
        .post(this.cardLink, this.newItem)
        .then((response) => {
          return response.data.data;
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });

      if (newItem) {
        this.$modal.hide("add");
        this.items.push(newItem);
        this.newItem = {
          title: "",
          type: "test",
          answers: [],
          audio_document: null,
        };
      }
    },
    async updateItem(item, key) {
      let items = JSON.parse(JSON.stringify(this.items));
      this.$loading(true);
      await this.$http
        .put(`${this.cardLink}/${item.id}`, item)
        .then((response) => {
          // items[key] = response.data.data;
          this.$set(items,key,response.data.data)
          return response.data.data;
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
          this.items = items;
        });
      //console.log(this.items);
    },
    async deleteItem(item, key) {
      this.$loading(true);
      let newItem = await this.$http
        .delete(`${this.cardLink}/${item.id}`)
        .then((response) => {
          this.items.splice(key, 1);
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
};
</script>
<style lang="scss">
.add {
  text-align: right;
  position: fixed;
  right: 0;
  top: 120px;
  z-index: 999;
  padding: 25px;
}

.ord {
  background: #f2f2f2;
  padding: 15px;
  border-radius: 20px;
}

ul.question {
  list-style: none;
  margin: 70px 0 0;
  padding: 0;

  & > li {
    position: relative;
    overflow: hidden;
    background: #f2f2f2;
    border-radius: 10px;
    margin-bottom: 20px;
    padding: 15px;

    & .control {
      margin-top: 20px;
    }
  }
}

.ql-editor {
  background: #fff;
  border-radius: 20px;
}

.answers {
  margin-top: 20px;

  & h6 {
    margin-bottom: 10px;
  }
}

.group {
  background: #fff;
  border-radius: 10px;
  padding: 10px 10px;
  margin-bottom: 30px;

  & > div {
    margin: 5px 0;
  }
}
</style>
